import { RouteConfig } from 'vue-router';
const PAGE_TITLE =
  '爱佑新生 心系妇幼 “1分钟说孕期健康”短视频有奖征集大赛暨“幸福亲子照”有奖征集点赞活动';
const baseUrl = '20220610AYXS';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'photo',
      name: `${baseUrl}-photo`,
      component: () => import('./pages/Photo.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'video',
      name: `${baseUrl}-video`,
      component: () => import('./pages/Video.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detail',
      name: `${baseUrl}-detail`,
      component: () => import('./pages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
